"use strict";

angular.module("portal.lookup").controller("UserLookupDetail", [
    "$q",
    "$scope",
    "$state",
    "$stateParams",
    "$rootScope",
    "Complaints",
    "Enterprise",
    "EnterprisePublicLookup",
    "LicenseRequests",
    "Services",
    "Users",
    function (
        $q,
        $scope,
        $state,
        $stateParams,
        $rootScope,
        Complaints,
        Enterprise,
        EnterprisePublicLookup,
        LicenseRequests,
        Services,
        Users
    ) {
        $scope.loading = true;
        $scope.looking_up = false;
        $scope.promises = [];
        $scope.parameters = {
            enterpriseID: $rootScope.enterpriseID
        };
        $scope.license_label = "License";

        $scope.detail_columns = [];
        $scope.user = $stateParams.user;

        Enterprise.getEnterpriseUserPublicAddresses().then(function (show) {
            if (show) {
                $scope.userPublicAddresses = true;
            } else {
                $scope.userPublicAddresses = false;
            }
        });

        if ($stateParams.lookup_object) {
            $scope.old_lookup_object = $stateParams.lookup_object;
        }

        if ($stateParams.priorState) {
            $scope.priorState = $stateParams.priorState;
        }

        // Make sure we have the enterprise details
        if ($rootScope.enterprise != null) {
            $scope.enterprise = $rootScope.enterprise;
        } else {
            if ($rootScope.userAccount !== null) {
                Enterprise.get($scope.parameters).then(function(result) {
                    $scope.enterprise = result;
                    $scope.loading = false;
                });
            } else {
                $scope.parameters.isPortal = true;
                Enterprise.getLess($scope.parameters).then(function(result) {
                    $scope.enterprise = result;
                    $scope.loading = false;
                });
            }
        }

        // Get the entity labels
        $scope.userLabel = $scope.enterprise.userLabels["USER"];
        $scope.serviceLabel = $scope.enterprise.serviceLabels["SERVICE"];

        if (!$scope.lookup_object) {
            $scope.lookup_object = {
                userID:
                    ($scope.old_lookup_object &&
                        $scope.old_lookup_object.userID) ||
                    $stateParams.id,
                enterprise_id: $rootScope.enterpriseID,
                records_offset: 0,
                records_total: 1,
                sort_fields: null,
                from_search: false
            };
        }

        // Get the user lookup detail columns, then check passed in user for existing columns
        EnterprisePublicLookup.get({
            enterpriseId: $rootScope.enterpriseID,
            code: "result",
            entityType: "user"
        }).then(function (result) {
            $scope.result_columns = [];
            $scope.investigation_columns = [];
            $scope.certification_columns = [];
            $scope.cert_attribute_columns = [];
            $scope.application_columns = [];
            $scope.user_services_columns = [];

            if (result != null) {
                result = result.map(function (c) {
                    return c;
                });

                $scope.result_columns = result.filter(function (c) {
                    return c.singular_relationship;
                });

                $scope.result_columns_investigations = result.filter(function (c) {
                    return (
                        !c.singular_relationship &&
                        c.category == "Investigation"
                    );
                });

                $scope.result_columns_applications = result.filter(function (c) {
                    return (
                        !c.singular_relationship && c.category == "Application"
                    );
                });

                $scope.result_columns_investigations.forEach(function (column) {
                    // create columns for list directive
                    $scope.investigation_columns.push({
                        label: column.label,
                        field: column.alias,
                        type: column.format_type,
                        revertTimeZone: true
                    });
                });

                $scope.result_columns_applications.forEach(function (column) {
                    // create columns for list directive
                    $scope.application_columns.push({
                        label: column.label,
                        field: column.alias,
                        type: column.format_type,
                        revertTimeZone:
                            column.format_type == "date"
                                ? column.field.toLowerCase() == "issue_date" ||
                                    column.field.toLowerCase() ==
                                    "expiration_date"
                                    ? true
                                    : false
                                : undefined
                    });
                });

                $scope.result_columns_certifications = result.filter(function (c) {
                    return (
                        !c.singular_relationship && c.category == "Certification List"
                    );
                });

                $scope.result_columns_certifications.forEach(function (column) {
                    // create columns for list directive
                    $scope.certification_columns.push({
                        label: column.label,
                        field: column.alias,
                        type: column.format_type,
                        revertTimeZone:
                            column.format_type == "date"
                                ? column.field.toLowerCase() == "issue_date" ||
                                    column.field.toLowerCase() ==
                                    "expiration_date" ||
                                    column.field.toLowerCase() ==
                                    "initial_issue_date"
                                    ? true
                                    : false
                                : undefined
                    });
                });

                // create columns for list directive
                $scope.cert_attribute_columns.push({
                    label: "Attribute Name",
                    field: "name",
                    type: "string"
                });

                // create columns for list directive
                $scope.cert_attribute_columns.push({
                    label: "Attribute Value",
                    field: "value",
                    type: "string"
                });

                $scope.result_columns_services = result.filter(function (c) {
                    return (
                        !c.singular_relationship &&
                        c.table_name == "user_services"
                    );
                });

                $scope.courseListColumn = result.find(function (c) {
                    return (
                        c.id == "e1b58668-38f3-4690-bc85-83c205751113" &&
                        c.field == "course_list" &&
                        c.alias == "course_list"
                    );
                });
                if ($scope.courseListColumn && $scope.enterprise.education_module == true) {
                    $scope.courseList = true;
                    $scope.courseListLabel = $scope.courseListColumn.label;
                }
                $scope.educationReportColumn = result.find(function (c) {
                    return (
                        c.id == "6819d430-afc5-4a9e-a3ad-477742321ea5" &&
                        c.field == "education_report" &&
                        c.alias == "education_report" &&
                        c.restricted == false
                    );
                })
                if ($scope.educationReportColumn && $scope.enterprise.education_module == true) {
                    $scope.educationReport = true;
                    $scope.educationReportLabel = $scope.educationReportColumn.label;
                }

                $scope.result_columns_services.forEach(function (c) {
                    $scope.user_services_columns.push({
                        label: c.label,
                        field: c.alias,
                        type: c.format_type,
                        link:
                            c.field == "name"
                                ? {
                                    // conditionally add link property
                                    state: "portal.menus.servicelookupdetail",
                                    params: [
                                        {
                                            name: "id",
                                            field: "id"
                                        },
                                        {
                                            name: "priorState",
                                            field: "priorState"
                                        },
                                        {
                                            name: "lookup_object",
                                            field: "lookup_object"
                                        }
                                    ]
                                }
                                : undefined,
                        revertTimeZone:
                            c.format_type == "date"
                                ? c.field.toLowerCase() == "issue_date" ||
                                    c.field.toLowerCase() == "expiration_date"
                                    ? true
                                    : false
                                : undefined
                    });
                });

                getUser().then(function (userInfo) {
                    $scope.user = userInfo;

                    if ($scope.user) {
                        if (!$scope.educationReport && $scope.enterprise.education_module == true) {
                            EnterprisePublicLookup.getEducationReportLookupPermission($scope.user.id).then(function (educationReportPermission) {

                                $scope.educationReportColumn = result.find(function (c) {
                                    return (
                                        c.id == "6819d430-afc5-4a9e-a3ad-477742321ea5" &&
                                        c.field == "education_report" &&
                                        c.alias == "education_report" &&
                                        c.restricted == true
                                    );
                                });
                                if ($scope.educationReportColumn && educationReportPermission) {
                                    $scope.educationReport = true;
                                    $scope.educationReportLabel = $scope.educationReportColumn.label;
                                }
                            });
                        }
                        if (
                            $scope.result_columns_certifications.length > 0 &&
                            !$scope.user.certifications
                        ) {
                            $scope.user.certifications_list_loading = true;
                            Users.getUserCertifications(
                                $scope.user.id,
                                true,
                                $rootScope.enterpriseID
                            ).then(function (result) {
                                $scope.user.certifications = result;
                                $scope.user.certifications_list_loading = false;
                            });
                        }

                        if (
                            $scope.result_columns_applications.length > 0 &&
                            !$scope.user.applications
                        ) {
                            $scope.user.applications_list_loading = true;
                            LicenseRequests.getByUserID(
                                $scope.user.id,
                                true,
                                $rootScope.enterpriseID
                            ).then(function (result) {
                                $scope.user.applications = result;
                                $scope.user.applications_list_loading = false;
                            });
                        }

                        if (
                            $scope.result_columns_investigations.length > 0 &&
                            !$scope.user.investigations
                        ) {
                            $scope.user.investigations_list_loading = true;
                            Complaints.getByUserID(
                                $scope.user.id,
                                true,
                                $rootScope.enterpriseID
                            ).then(function (result) {
                                $scope.user.investigations = result;
                                $scope.user.investigations_list_loading = false;
                            });
                        }

                        if (
                            $scope.result_columns_services.length > 0 &&
                            !$scope.user.services
                        ) {
                            $scope.user.services_list_loading = true;
                            Services.getByUserID(
                                $scope.user.id,
                                true,
                                $rootScope.enterpriseID
                            ).then(function (result) {
                                $scope.user.services = result.map(function (
                                    service
                                ) {
                                    service.priorState = $state.current.name;
                                    service.lookup_object =
                                        $scope.lookup_object;
                                    return service;
                                });
                                $scope.user.services_list_loading = false;
                            });
                        }

                        $scope.promises.push(
                            Users.getUserEMSLevels({
                                userID: $scope.user.id
                            }).then(function (EMSLevels) {
                                $scope.user.EMSLevels = EMSLevels;
                            })
                        );

                        $scope.promises.push(
                            Users.getUserEndorsements({
                                userID: $scope.user.id
                            }).then(function (endorsements) {
                                $scope.user.endorsements = endorsements;
                            })
                        );

                        $scope.promises.push(
                            Users.getUserInstructorLevels({
                                userID: $scope.user.id
                            }).then(function (instructorLevels) {
                                $scope.user.instructorLevels = instructorLevels;
                            })
                        );

                        $scope.promises.push(
                            Users.getUserEvaluatorLevels({
                                userID: $scope.user.id
                            }).then(function (evaluatorLevels) {
                                $scope.user.evaluatorLevels = evaluatorLevels;
                            })
                        );

                        $scope.promises.push(
                            Users.getUserInstructingTopics({
                                userID: $scope.user.id
                            }).then(function (instructingTopics) {
                                $scope.user.instructingTopics = instructingTopics;
                            })
                        );

                        $q.all($scope.promises).then(function () {
                            $scope.loading = false;
                        }).catch(function (response) {
                            // handle error
                        });  
                    }
                });
            }
        });

        function getUser() {
            var d = $q.defer();

            // THIS WAS A BAD IDEA, JUST LOOK UP THE USER
            // if (!$stateParams.user) {
            if (!$scope.lookup_object.userID) {
                $scope.lookup_object.userID = $stateParams.id; // use the id if no user
            }

            Users.publicLookupUser($scope.lookup_object).then(function (result) {
                var user = result && result.pop();

                $scope.include_suffix = false;
                $scope.include_middle = false;

                $scope.result_columns.forEach(function (s) {
                    if (s.alias == 'suffix') {
                        $scope.include_suffix = true;
                    }
                    if (s.alias == 'middle_name') {
                        $scope.include_middle = true;
                    }
                    if (s.alias == 'user_id_alert_id') {
                        $scope.userAlertsUsed = true;
                    }
                });

                user['header_name'] = user.last_name;
                if ($scope.include_suffix && user.suffix != '' && user.suffix != null) {
                    user['header_name'] = user['header_name'] + ' ' + user.suffix;
                }

                user['header_name'] = user['header_name'] + ', ' + user.first_name;

                if ($scope.include_middle && user.middle_name != '' && user.middle_name != null) {
                    user['header_name'] = user['header_name'] + ' ' + user.middle_name;
                }

                if (user.alert_count > 0 && $scope.userAlertsUsed) {
                    Users.getUserAlerts({
                        userID: user.id,
                        is_public: true
                    }).then(function (result) {
                        user.alerts = result;

                        if (user.alerts.length > 0) {
                            user.alerts_concat = "";
                            user.alerts.forEach(function (alert) {
                                // slightly faster than using .reduce
                                user.alerts_concat += ", " + alert.message;
                            });
                        }
                    });
                }

                d.resolve(user);
            });
            /*}
            else {
                d.resolve($stateParams.user); // just return the user we got in state params
            }*/

            return d.promise;
        }

        $scope.userPublicAddressCheck = function (label) {
            if (label.includes('Public')) {
                return ($scope.userPublicAddresses) ? true : false;
            } else {
                // Not public address, pass
                return true;
            }
        };
    }
]);
